import { breakpoints as defaultBreakpoints } from "./breakpoints";
// helper to deconstruct mq string
var getMqData = function(query, breakpoints) {
    var parts = query.split("-");
    var bpIndex = breakpoints.findIndex(function(bp) {
        return bp.name === parts[0];
    });
    if (bpIndex === -1) return false;
    var lowEnd = breakpoints[bpIndex].width;
    var highEnd = bpIndex < breakpoints.length - 1 ? breakpoints[bpIndex + 1].width : null;
    return {
        parts: parts,
        bpIndex: bpIndex,
        lowEnd: lowEnd,
        highEnd: highEnd
    };
};
/**
 * Generate mediaquery to use in CSS
 *
 * @param  {string} name Media query name (straight viewport or with optional '-only' suffix)
 * @param {BreakPoints} [breakpoints=defaultBreakpoints] Optionally override default breakpoints
 * @return {string}      Generated media query string ready to insert into CSS
 */ var mq = function(name) {
    var breakpoints = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultBreakpoints;
    var mqData = getMqData(name, breakpoints);
    if (!mqData) return "@media screen, print"; // failing gracefully
    if (mqData.parts[1] && mqData.parts[1] === "only") {
        return !mqData.highEnd ? "@media (min-width: ".concat(mqData.lowEnd, "px)") : "@media (min-width: ".concat(mqData.lowEnd, "px) and (max-width: ").concat(mqData.highEnd - 1, "px)");
    }
    return "@media (min-width: ".concat(mqData.lowEnd, "px)");
};
/**
 * Generate mq function with overridden breakpoints
 * @param breakpoints the breakpoints to override the default breakpoints
 * @returns a function to generate a mediaquery to use in CSS
 */ var mqFactory = function(breakpoints) {
    return function(name) {
        return mq(name, breakpoints);
    };
};
/**
 * Breakpoint getter, i.e. if you need the width value for a specific breakpoint in other configs
 *
 * @param  {string} name Breakpoint name (i.e. "lg")
 * @return {int}         Width of breakpoint
 */ var getBreakpoint = function(name) {
    var breakpoints = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultBreakpoints;
    var ref;
    return (ref = breakpoints.find(function(bp) {
        return bp.name === name;
    })) === null || ref === void 0 ? void 0 : ref.width;
};
export { mq, mqFactory, getBreakpoint };
